var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    stroke: "#E2E2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1562 23.125V23.2813H25C24.3786 23.282 23.7829 23.5291 23.3435 23.9685C22.9041 24.4079 22.657 25.0036 22.6562 25.625V36.875C22.657 37.4964 22.9041 38.0921 23.3435 38.5315C23.7829 38.9709 24.3786 39.218 25 39.2188H32.5C33.1214 39.218 33.7171 38.9709 34.1565 38.5315C34.5959 38.0921 34.843 37.4964 34.8438 36.875V36.7188H35C35.6214 36.718 36.2171 36.4709 36.6565 36.0315C37.0959 35.5921 37.343 34.9964 37.3438 34.375V23.125C37.343 22.5036 37.0959 21.9079 36.6565 21.4685C36.2171 21.0291 35.6214 20.782 35 20.7812H27.5C26.8786 20.782 26.2829 21.0291 25.8435 21.4685C25.4041 21.9079 25.157 22.5036 25.1562 23.125ZM33.9062 36.875C33.9058 37.2478 33.7575 37.6052 33.4939 37.8689C33.2302 38.1325 32.8728 38.2808 32.5 38.2813H25C24.6272 38.2808 24.2698 38.1325 24.0061 37.8689C23.7425 37.6052 23.5942 37.2478 23.5938 36.875V25.625C23.5942 25.2522 23.7425 24.8948 24.0061 24.6311C24.2698 24.3675 24.6272 24.2192 25 24.2188H32.5C32.8728 24.2192 33.2302 24.3675 33.4939 24.6311C33.7575 24.8948 33.9058 25.2522 33.9062 25.625V36.875ZM36.4062 23.125V34.375C36.4058 34.7478 36.2575 35.1052 35.9939 35.3689C35.7302 35.6325 35.3728 35.7808 35 35.7813H34.8438V25.625C34.843 25.0036 34.5959 24.4079 34.1565 23.9685C33.7171 23.5291 33.1214 23.282 32.5 23.2813H26.0938V23.125C26.0942 22.7522 26.2425 22.3948 26.5061 22.1311C26.7698 21.8675 27.1272 21.7192 27.5 21.7188H35C35.3728 21.7192 35.7302 21.8675 35.9939 22.1311C36.2575 22.3948 36.4058 22.7522 36.4062 23.125Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.34ce254d98de807dc613ab01625a5d89.svg";
export { ForwardRef as ReactComponent };